"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawPlane = void 0;
var drawPlane = function (svg, config, dataPoints, yAxisMarks, destPlane) {
    var _a;
    svg.rect('100%', '100%').fill({ color: config.backgroundColor ? config.backgroundColor : 'transparent' });
    var fontSize = config.yAxis.fontSize || 30;
    yAxisMarks.map(function (it) {
        svg.line(config.xAxis.marginStart, it[1], config.width - config.xAxis.marginEnd, it[1])
            .stroke({ width: 1, color: '#bbb' });
        svg.text(function (tspan) { return tspan.move(Math.max(config.xAxis.marginStart - fontSize * 3, fontSize * 0.6), it[1] - fontSize)
            .text("" + it[0]); }).font({ size: fontSize });
    });
    if (config.xAxis.label && config.xAxis.series) {
        var LABEL_WIDTH_1 = config.xAxis.series[0].toString().split("\n")[0].length * fontSize * 1.6;
        var lastLabelPos_1 = 0;
        dataPoints.map(function (it, i) {
            var current = it[0] - config.xAxis.marginStart;
            if (current != 0 && lastLabelPos_1 + LABEL_WIDTH_1 > current)
                return;
            lastLabelPos_1 = current;
            svg.text(function (tspan) { return tspan.move(it[0] - 10, destPlane[0][0][1])
                .text(config.xAxis.series[i]); }).font({ size: fontSize });
            svg.line(it[0], destPlane[0][0][1], it[0], destPlane[0][0][1] + fontSize * 0.4).stroke({ color: config.xAxis.color, width: 4 });
        });
    }
    svg.line(destPlane[1]).stroke({ color: config.yAxis.color, width: 4 });
    svg.line(destPlane[0]).stroke({ color: config.xAxis.color, width: 4 });
    var LABEL_OFFSET = 18;
    if (config.yAxis.label) {
        svg.text(function (tspan) { return tspan.move(LABEL_OFFSET, LABEL_OFFSET)
            .text(config.yAxis.label)
            .font({ size: fontSize }); });
    }
    if ((_a = config.legends) === null || _a === void 0 ? void 0 : _a.length) {
        var LINE_WIDTH_1 = 40;
        config.legends.map(function (legend, i) {
            var TEXT_SIZE = 200;
            svg.text(function (tspan) { return tspan.move(config.width - config.xAxis.marginEnd - ((TEXT_SIZE - LINE_WIDTH_1) * (i + 1)) + LINE_WIDTH_1 + 18, LABEL_OFFSET - 1)
                .text(legend.text)
                .font({ size: fontSize }); });
            var lineXStart = config.width - config.xAxis.marginEnd - ((TEXT_SIZE - LINE_WIDTH_1) * (i + 1));
            var lineXEnd = lineXStart + LINE_WIDTH_1;
            var lineY = LABEL_OFFSET + fontSize - 3;
            svg.line(lineXStart, lineY, lineXEnd, lineY)
                .stroke({ width: 12, color: legend.color });
        });
    }
};
exports.drawPlane = drawPlane;
